import React, { useState } from "react";
import { Container, Row, Col, Card, Button, ButtonGroup } from "reactstrap";
import "../styles/carousel.css";
import dayjs from "dayjs";
import { useInterval } from "react-use";

function PreviewCarousel(props) {
	const { items = [], showItems, action } = props;
	const [count, setCount] = useState(0);
	const [delay] = useState(10000);
	const [isRunning, toggleIsRunning] = useState(true);

	useInterval(
		() => {
			if (count === items.length - 1) {
				setCount(0);
			} else {
				setCount(count + 1);
			}
		},
		isRunning ? delay : null
	);

	const show = items[count];
	const handleNext = () => {
		setCount((it) => {
			return it === items.length - 1 ? 0 : it + 1;
		});
		toggleIsRunning(false);
	};
	const hanedleBack = () => {
		setCount((it) => it - 1);
		toggleIsRunning(false);
	};
	if (!show) return <div> </div>;
	return (
		<Card style={{ padding: 8 }}>
			{action && (
				<div style={{ position: "absolute", top: 4, right: 4, zIndex: 1000 }}>
					{action}
				</div>
			)}
			<Container fluid>
				<Row>
					<Col xs={12} sm={12} md={showItems ? 9 : 12}>
						<h3>{items[count].title}</h3>
						<Row>
							<Col md={5}>
								<img
									src={`${process.env.PUBLIC_URL}/${items[count].image}`}
									alt="primary"
									className="img-responsive img-thumbnail main-img"
								/>
								{items[count].source && (
									<figcaption className="figure-caption">
										<small>Image Souce: {items[count].source}</small>
									</figcaption>
								)}
							</Col>
							<Col md={7}>
								<p>
									<strong>
										{dayjs(items[count].date).format("MM/DD/YYYY")}
										{": "}
									</strong>
									{items[count].text}
								</p>
								{items[count].actions && (
									<div>
										{/* <ButtonGroup> */}
										{items[count].actions.map(({ text, ...others }) => (
											<Button
												outline
												size="sm"
												{...others}
												style={{ marginRight: 4, marginBottom: 2 }}
											>
												{text}
											</Button>
										))}
										{/* </ButtonGroup> */}
									</div>
								)}
							</Col>
						</Row>
					</Col>
					{showItems && (
						<Col xs={12} sm={12} md={3}>
							{items.map((item, i) => (
								<Col xs={12} key={`item-${i}`}>
									{i !== count && (
										<div
											onClick={() => setCount(i)}
											style={{
												border: "1px solid #dee2e6",
												padding: 4,
												borderRadius: 2,
												cursor: "pointer",
											}}
										>
											{item.shortTitle ? (
												<h5 className="nav-title">{item.shortTitle}</h5>
											) : (
												<p className="nav-title">{item.title}</p>
											)}
											<img
												src={`${process.env.PUBLIC_URL}/${item.image}`}
												alt="carousel-img-thumbnail"
												className="img-responsive  img-nav"
											/>
										</div>
									)}
								</Col>
							))}
						</Col>
					)}
				</Row>
			</Container>
			<div
				style={{
					paddingTop: 8,
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
				}}
			>
				<Button
					size="sm"
					outline
					color="info"
					onClick={hanedleBack}
					disabled={count === 0}
				>
					Previous
				</Button>
				<ButtonGroup color="info">
					{items.map((it, i) => (
						<Button
							color="info"
							key={i}
							close
							aria-label={`list-item-${i}`}
							style={{ fontSize: "1rem" }}
							onClick={() => {
								setCount(i);
								toggleIsRunning(false);
							}}
						>
							{count === i ? (
								<span aria-hidden>&#9679;</span>
							) : (
								<span aria-hidden>&#9675;</span>
							)}
						</Button>
					))}
				</ButtonGroup>
				<Button
					size="sm"
					outline
					color="info"
					onClick={handleNext}
					// disabled={count === items.length - 1}
				>
					Next
				</Button>
			</div>
		</Card>
	);
}
export default PreviewCarousel;
